
export type LoadBalanceBehavior = "None" | "UseSessionContext";